import { render, staticRenderFns } from "./DM_downloadList.vue?vue&type=template&id=0be55a7e&scoped=true&"
import script from "./DM_downloadList.vue?vue&type=script&lang=js&"
export * from "./DM_downloadList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be55a7e",
  null
  
)

export default component.exports